module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "aria-label": "menu de opciones de accesibilidad"
    }
  }, [_c('div', {
    staticClass: "menu-acces menubots text-xs-right"
  }, [_c('ul', _vm._l((_vm.listBots), function(bot, index) {
    return _c('li', {
      key: index
    }, [_c('button', {
      staticClass: "hvr-grow botbor",
      class: ('bot-' + index),
      attrs: {
        "tabindex": "1",
        "aria-label": bot.name
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          bot.clickBot($event)
        }
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c5802a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Accesmenu.vue
// module id = 941
// module chunks = 1